import React, { useEffect, useRef, useState, useTransition } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button, IconButton, Popover, Typography } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import { useLocation, useNavigate } from 'react-router-dom'
import StepperCustom from '../../../../components/step/Stepper'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import { cancel_order_cart, cart_payment, ELibraryFrontApi, payment_lock_item } from '../../../../api/e-library/e_library_front.api'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { LIBRARY_PAYMENT_STATUS, media_type_data_category } from '../../enum/elibrary_enum'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal'
import PaymentCart from './PaymentCart'
import { PaymentChannelApi } from '../../../../api/payment-channel/payment-channel.api'
import { BankAccountTypeOptions, bankListArray } from '../../../cms/course-online/manage-payment-channel/enum/manage_payment'
import moment from 'moment'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import StatusCustom from '../../../../components/status/statusCustom'

type Props = {}



type QuantityDeletePopoverProps = {
    maxQty: number;              // จำนวนสูงสุดที่ลบได้ (เช่น list.qty)
    onConfirm: (qty: number) => void;  // callback ส่งจำนวนไปลบ
    buttonText?: string;
    disabled?: boolean;
    defaultQty?: number;
};

export function QuantityDeletePopover({
    maxQty,
    onConfirm,
    buttonText = "ลบ",
    disabled,
    defaultQty
}: QuantityDeletePopoverProps) {
    const anchorRef = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState(false);
    const [qty, setQty] = useState(defaultQty ?? 1);

    const handleOpen = () => {
        setQty(defaultQty ?? 1);
        setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const dec = () => setQty((v) => Math.max(1, v - 1));
    const inc = () => setQty((v) => Math.min(maxQty, v + 1));

    return (
        <>
            <Button
                ref={anchorRef}
                onClick={handleOpen}
                startIcon={<DeleteForeverIcon />}
                color="error"
                variant="contained"
                fullWidth
                disabled={disabled || maxQty <= 0}
            >
                {buttonText}
            </Button>

            <Popover
                open={open}
                onClose={handleClose}
                anchorEl={anchorRef.current}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{ sx: { p: 2, borderRadius: 2, width: 260 } }}
            >
                <Box className="flex flex-col gap-3">
                    <Typography variant="subtitle1">เลือกลบกี่รายการ</Typography>

                    <Box className="flex items-center justify-between">
                        <IconButton onClick={dec} size="small" disabled={qty <= 1}>
                            <RemoveIcon />
                        </IconButton>
                        <Typography variant="h5" sx={{ minWidth: 40, textAlign: "center" }}>
                            {qty}
                        </Typography>
                        <IconButton onClick={inc} size="small" disabled={qty >= maxQty}>
                            <AddIcon />
                        </IconButton>
                    </Box>

                    <Typography variant="body2" color="text.secondary">
                        จำนวนคงเหลือ {maxQty - qty} รายการ
                    </Typography>

                    <Box className="flex gap-2">
                        <Button onClick={handleClose} fullWidth variant="outlined">
                            ยกเลิก
                        </Button>
                        <Button
                            fullWidth
                            color="error"
                            variant="contained"
                            onClick={() => {
                                onConfirm(qty);
                                handleClose();
                            }}
                        >
                            ยืนยันลบ
                        </Button>
                    </Box>
                </Box>
            </Popover>
        </>
    );
}
const ShoppingCartBooks = ({ }: Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pathname = location.pathname;
    const base_api = useSelector((state: RootState) => state.api.image_api)!;
    const profile = useSelector((state: RootState) => state.profile.profile) as any;


    // HOOKS
    const [isPending, startTransition] = useTransition();
    const [step, set_step] = useState<number>(0);
    const [cart_data, set_cart_data] = useState<any[]>([]);
    const [checked_cart, set_checked_cart] = useState<number[]>([]);
    const [is_payment, set_is_payment] = useState<boolean>(false);
    const [is_detail_payment, set_is_detail_payment] = useState<boolean>(false);
    const [payment_data, set_payment_data] = useState<any[]>([]);
    const [history_data, set_history_data] = useState<any[]>([]);
    const [order_data, set_order_data] = useState<any[]>([]);
    const [min_exp_date, set_min_exp_date] = useState<Date | null>(null);
    const [order_number, set_order_number] = useState<string>("");
    const [pay_file_data, set_pay_file_data] = useState<any>(null);
    const [data_detail, set_data_detail] = useState<any>(null);

    const [payment_channel_data, set_payment_channel_data] = useState<any>(null);
    const [select_bank, set_select_bank] = useState<any>(null);
    const [payment_file, set_payment_file] = useState<File | null>(null);
    const [form_payment, set_form_payment] = useState<{ payment_date: string, payment_time: string, payment_amount: string }>({
        payment_amount: "",
        payment_date: "",
        payment_time: ""
    })


    // FUNC.
    const handleToggleCheck = (id: number) => {
        set_checked_cart((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleDeleteItems = async (id_library_head: number, qty_to_delete: number) => {
        dispatch(setLoading())
        try {
            await ELibraryFrontApi.cartDelete({ qty: +qty_to_delete, id_library_head }).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", `ลบรายการ จำนวน ${qty_to_delete} รายการสำเร็จ`);
                    // set_checked_cart([])
                    // set_payment_data([]);
                    handleGetCartBookData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการไม่สำเร็จ");
            })
        } catch (e) {
            console.error(e);
        } finally {
            dispatch(unsetLoading())
        }
    };

    const handlePayment = (id_library_head?: number) => {
        set_is_payment(true);
        if (id_library_head) {
            set_payment_data(cart_data?.filter((x) => id_library_head === x?.id_library_head));
        } else {
            set_payment_data(cart_data?.filter((x) => checked_cart.includes(x?.id_library_head)));
        }
    }

    const handleClearOrder = () => {
        set_checked_cart([]);
        set_payment_data([]);
        set_is_payment(false);
        set_form_payment({ payment_amount: "", payment_date: "", payment_time: "" });
        set_payment_file(null);
        set_order_number("");
    }


    const handleCancelOrder = async () => {
        dispatch(setLoading());
        const body_cancel: cancel_order_cart[] = order_data?.map((list) => {
            return {
                id_library_detail: list?.id_library_detail,
                id_library_history: list?.id_library_history
            }
        })
        await ELibraryFrontApi.cancelOrder(body_cancel).then((res) => {
            if (res.status < 300) {
                handleClearOrder();
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetPayment = async () => {
        dispatch(setLoading());
        await PaymentChannelApi.getPaymentChannelByType({ type_channel_payment: "E_LIBRARY" }).then((res) => {
            if (res.status < 300) {
                const paymentChannel = res.data?.data?.paymentChannel;
                set_payment_channel_data(paymentChannel);
                if (paymentChannel?.bank_name_th) {
                    const data_value = bankListArray?.find((x) => x.name === paymentChannel?.bank_name_th) || null
                    set_select_bank(data_value);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetCartBookData = async () => {
        dispatch(setLoading());
        await ELibraryFrontApi.listCart().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_cart_data(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleUploadFilePayment = async (file: File): Promise<number | null> => {
        try {
            const file_form_data = new FormData();
            file_form_data.append("file", file);
            const res = await ELibraryFrontApi.uploadFilePayment(file_form_data);
            if (res.status < 300) {
                const id_file = res.data?.data?.id_library_payment_file ?? null;
                return id_file;
            }
            return null;
        } catch (err) {
            console.log(err);
            return null;
        }
    };
    const handleCheckLockItem = async (data_check: any[]): Promise<boolean> => {
        const body_lock_item: payment_lock_item[] = data_check?.map((list) => {
            return {
                id_library_head: list?.id_library_head,
                qty: list?.qty ? +list?.qty : 0
            }
        })
        dispatch(setLoading());
        return await ELibraryFrontApi.paymentLockItem(body_lock_item).then(async (res) => {
            if (res.status < 300) {
                const min_exp_date = res.data?.data?.min_exp_date;
                const list_items: any[] = res.data?.data?.list_items || [];
                if (list_items?.length > 0) {
                    set_order_data(list_items);
                }
                if (min_exp_date) {
                    set_min_exp_date(min_exp_date);
                }
                return true
            } else {
                return false
            }
        }).catch((err) => {
            console.log(err);
            alertError(err?.response?.data?.message || "ชำระเงินไม่สำเร็จ")
            return false
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleSubmitCartPayment = async () => {
        let id_file_payment: number | null = null;
        if (!form_payment.payment_date || !form_payment.payment_time) {
            return alertError("ข้อมูลไม่ครบถ้วน", "ระบุเวลาและวันที่");
        }
        if (!form_payment.payment_amount) {
            return alertError("ข้อมูลไม่ครบถ้วน", "ระบุยอดเงิน (บาท)");
        }
        if (!payment_file) return alertError("ข้อมูลไม่ครบถ้วน", "กรุณาแนบไฟล์");

        alertActive("ยืนยันการชำระเงิน", "หมายเหตุ : ในกรณีสั่งซื้อ ทางผู้ซื้อต้องดำเนินการเข้าไปรับหนังสือที่วิทยาลัยพุทธศาสตร์นานาชาติเท่านั้น ท่านต้องการยืนยันการชำระเงิน ใช่หรือไม่", undefined, undefined, async () => {
            const payment_date_time = `${moment(form_payment.payment_date).format("YYYY-MM-DD")}T${form_payment.payment_time}`;
            dispatch(setLoading());
            if (payment_file) {
                const id_file = await handleUploadFilePayment(payment_file);
                id_file_payment = id_file
            }
            let body: cart_payment = {
                amount_pay: form_payment?.payment_amount ? +form_payment?.payment_amount : 0,
                id_file: id_file_payment,
                library_payment_head_date: payment_date_time,
                items: payment_data?.map((list) => {
                    return {
                        id_library_head: list?.id_library_head,
                        qty: list?.qty ? +list?.qty : null,
                    }
                }),
            }
            await ELibraryFrontApi.cartPayment(body).then((res) => {
                if (res.status < 300) {
                    set_is_payment(false);
                    alertSuccess("ยืนยันการชำระเงิน", "ยืนยันการชำระเงิน เรียบร้อยแล้ว กรุณารอทางเจ้าหน้าที่ตรวจสอบ");
                    handleGetHistoryCart();
                    set_step(1);
                    set_payment_file(null);
                }
            }).catch((err) => {
                console.log(err);
                alertError("ชำระเงินไม่สำเร็จ", err?.response?.data?.message || "ลองใหม่อีกครั้ง");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleFindOnePaymentData = async (id_library_payment_head: number) => {
        dispatch(setLoading());
        await ELibraryFrontApi.findOnePayment(id_library_payment_head).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                const library_pay_details = response?.library_pay_details || [];

                const library_pay_files: any[] = response?.library_pay_files || [];
                const library_payment_head_date = response?.library_payment_head_date || null;

                if (library_pay_files?.length > 0) {
                    set_pay_file_data(library_pay_files[0]);
                }
                set_min_exp_date(response?.exp_date_payment || "");
                set_payment_data(library_pay_details);
                set_order_number(response?.order_number || "")
                set_form_payment({
                    payment_amount: response?.total_amount || "",
                    payment_date: library_payment_head_date ? moment(library_payment_head_date).format("YYYY-MM-DD") : "",
                    payment_time: library_payment_head_date ? moment(library_payment_head_date).format("HH:mm") : ""
                })
                set_is_detail_payment(true);
                set_data_detail(response);

                console.log(response, 'response');
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetHistoryCart = async () => {
        await ELibraryFrontApi.historyCart().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_history_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }



    useEffect(() => {
        handleGetHistoryCart();
        handleGetCartBookData();
        handleGetPayment();
    }, [])


    // console.log(payment_data, 'payment_data')
    // console.log(payment_channel_data, 'payment_channel_data')
    // console.log(form_payment, 'form_payment')


    return (
        <ContainerLayout
            title={is_payment ? "ชำระเงิน" : "ตะกร้าสินค้า"}
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library",
                            name: "จัดการข้อมูล E-Library",
                            pathName: routeName.e_library.books,
                            disabled_match: true
                        },
                        {
                            key: 'A',
                            name: "ตะกร้าสินค้า",
                            pathName: pathname,
                            disabled_match: is_payment,
                            onClick: () => is_payment ? set_is_payment(false) : undefined
                        },
                        ...(is_payment ? [
                            {
                                key: 'A',
                                name: "ชำระเงิน",
                                pathName: pathname,
                                onClick: () => {
                                    set_is_payment(true);
                                }
                            }
                        ] : [])
                    ]}
                />
            }
            buttonContent={(is_payment) ? (
                <Box className="flex justify-end gap-4 items-center">
                    <Button sx={{ borderRadius: "8px" }} variant='outlined' onClick={() => {
                        handleCancelOrder();
                    }}>ย้อนกลับ</Button>
                    <Button disabled={isPending} onClick={() => {
                        startTransition(() => {
                            handleSubmitCartPayment()
                        })
                    }} color='success' variant='contained'>ยืนยัน</Button>
                </Box>
            ) : is_detail_payment ? <Button sx={{ borderRadius: "8px" }} variant='outlined' onClick={() => {
                set_is_detail_payment(false);
            }}>ย้อนกลับ</Button> : undefined}
            content={
                <Box>
                    {(is_payment || is_detail_payment) ? (
                        <React.Fragment>
                            <PaymentCart
                                bill_no={order_number}
                                bill_date={data_detail?.created_date || null}
                                customer_name={profile?.first_name ? `${profile?.first_name || ""} ${profile?.last_name || ""}` : ""}
                                payment_file={payment_file}
                                file_path={pay_file_data ? `${base_api}/${pay_file_data?.file_path}${pay_file_data?.file_name}` : undefined}
                                onFileChange={(nf) => set_payment_file(nf)}
                                pay_date={min_exp_date}
                                is_management_borrow={is_detail_payment}
                                payment_amount={form_payment.payment_amount}
                                onPaymentAmountChange={(p) => set_form_payment((prev) => ({ ...prev, payment_amount: p }))}
                                onPaymentDateChange={(p) => set_form_payment((prev) => ({ ...prev, payment_date: p }))}
                                onPaymentTimeChange={(p) => set_form_payment((prev) => ({ ...prev, payment_time: p }))}
                                payment_date={form_payment.payment_date}
                                payment_time={form_payment.payment_time}
                                payment_list_data={payment_data?.map((list) => {
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id_library_head: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        library_type_name: "",
                                        price: list?.price_amount,
                                        qty: list?.qty
                                    }
                                })}

                                payment_icon_url={select_bank?.icon || ""}
                                payment_name={payment_channel_data?.account_name_th || "-"}
                                payment_name_en={payment_channel_data?.account_name_eng || "-"}
                                payment_no={payment_channel_data?.account_no || "-"}
                                payment_type={BankAccountTypeOptions?.find((x) => x.value === payment_channel_data?.account_type)?.label || "-"}
                            />
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Box sx={{ maxWidth: 'fit-content', margin: "0 auto" }}>
                                <StepperCustom
                                    setStep={(st) => set_step(st)}
                                    step={step}
                                    view
                                    maxWidthScroll='600px'
                                    sx={{ maxWidth: "420px", margin: '0 auto' }}
                                    stepLabel={[
                                        {
                                            isAccept: true,
                                            name: "สินค้าในตะกร้า",
                                            disabled: false,
                                            icon: <ShoppingCartIcon />
                                        },
                                        {
                                            isAccept: true,
                                            name: "ประวัติการทำรายการ",
                                            disabled: false,
                                            icon: <ReceiptLongIcon />
                                        },
                                    ]}
                                />
                            </Box>

                            {step === 0 && (
                                <Box className="flex flex-col gap-4">
                                    {cart_data?.map((list, i) => {
                                        const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                        const isChecked = checked_cart.includes(list.id_library_head);
                                        return (
                                            <Box data-aos="fade-left"
                                                data-aos-anchor="#example-anchor"
                                                data-aos-duration="500"
                                                className="flex flex-col lg:flex-row justify-between gap-4 min-h-[158px] bg-[#F6F6F6] rounded-[16px] py-[24px] px-[16px]" key={`key_${list?.id_library_head}_${i + 1}`}>
                                                <Box className="flex w-full gap-4">
                                                    <Box className="flex justify-start items-center">
                                                        <CheckBoxCustom checked={isChecked} setChecked={() => handleToggleCheck(list.id_library_head)} />
                                                    </Box>
                                                    <Box className="w-full max-w-[78px] h-[110px]">
                                                        <img loading='lazy' className='object-cover w-full h-full' src={img_url} alt={list?.file_name} />
                                                    </Box>
                                                    <Box className="flex flex-col w-full gap-2">
                                                        <Box className="flex gap-2 justify-start items-end">
                                                            <Typography variant='h5' className="line-clamp-1">
                                                                {list?.library_head_name || "-"}
                                                            </Typography>
                                                            <Typography className="line-clamp-1">
                                                                {list?.library_author_by || "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box className="flex gap-2">
                                                            <Typography className="line-clamp-1">
                                                                ประเภท : {media_type_data_category?.find((x) => x.value === list?.library_category_name)?.name || "-"}
                                                            </Typography>
                                                            <Typography className="line-clamp-1">
                                                                จำนวน {Number(list?.qty || "0")} รายการ ราคา {(Number(list?.price_amount || "0") * Number(list?.qty || "1")).toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    minimumIntegerDigits: 2
                                                                }) || ""} บาท
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box className="flex justify-end items-center flex-col gap-4 min-w-[120px]">
                                                    <Button onClick={async () => {
                                                        const check_payment = await handleCheckLockItem(cart_data?.filter((x) => list?.id_library_head === x?.id_library_head));
                                                        if (check_payment) {
                                                            handlePayment(list?.id_library_head);
                                                        }
                                                    }} fullWidth startIcon={<PriceCheckIcon />} color='success' variant='contained'>
                                                        ชำระเงิน
                                                    </Button>
                                                    {/* <Button fullWidth startIcon={<DeleteForeverIcon />} color='error' variant='contained'>ลบ</Button> */}

                                                    <QuantityDeletePopover
                                                        maxQty={Number(list?.qty || 0)}
                                                        onConfirm={(qty) => handleDeleteItems(list.id_library_head, qty)}
                                                        defaultQty={+list?.qty || 0}
                                                    />
                                                </Box>
                                            </Box>
                                        )
                                    })}
                                </Box>
                            )}


                            {step === 1 && (
                                <Box className="w-full flex flex-col gap-4">
                                    {history_data?.length > 0 ? history_data?.map((list, i) => {
                                        const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                                        return (
                                            <Box data-aos="fade-left"
                                                data-aos-anchor="#example-anchor"
                                                data-aos-duration="500"
                                                className="flex flex-col lg:flex-row justify-between gap-4 min-h-[158px] bg-[#F6F6F6] rounded-[16px] py-[24px] px-[16px]" key={`key_${list?.id_library_head}_${i + 1}`}>
                                                <Box className="flex w-full gap-4">
                                                    <Box className="w-full max-w-[78px] h-[110px]">
                                                        <img loading='lazy' className='object-cover w-full h-full' src={img_url} alt={list?.file_name} />
                                                    </Box>
                                                    <Box className="flex flex-col gap-2">
                                                        <Box>
                                                            #บิลเลขที่ {list?.order_number || "-"}
                                                        </Box>
                                                        <Box className="flex gap-2 justify-start items-end">
                                                            <Typography variant='h5' className="line-clamp-1">
                                                                {list?.library_head_name || "-"}
                                                            </Typography>
                                                            <Typography className="line-clamp-1">
                                                                {list?.library_author_by || "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box className="flex w-full gap-2">
                                                            <Typography className="line-clamp-1">
                                                                ประเภท : {media_type_data_category?.find((x) => x.value === list?.library_category_name)?.name || "-"}
                                                            </Typography>
                                                            <Typography className="line-clamp-1">
                                                                จำนวน {Number(list?.qty || "0")} รายการ ราคา {(Number(list?.price_amount || list?.total_amount || "0") * Number(list?.qty || "1")).toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    minimumIntegerDigits: 2
                                                                }) || ""} บาท
                                                            </Typography>
                                                        </Box>
                                                        <Box className="flex justify-start items-center">
                                                            <StatusCustom
                                                                disableMaxWidth
                                                                sx={{ maxWidth: "fit-content", px: 3 }}
                                                                text={list?.library_payment_head_status}
                                                                type={list?.library_payment_head_status}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box className="flex justify-end items-center flex-col gap-4 min-w-[120px]">
                                                    <Button disabled={!list?.id_library_payment_head} onClick={() => list?.id_library_payment_head && handleFindOnePaymentData(list?.id_library_payment_head)} fullWidth startIcon={<VisibilityOutlinedIcon />} color='success' variant='contained'>
                                                        ดูข้อมูล
                                                    </Button>
                                                </Box>
                                            </Box>
                                        )
                                    }) : <Typography>ไม่พบข้อมูล...</Typography>}
                                </Box>
                            )}








                            {cart_data?.length > 0 && step === 0 && (
                                <Box my={4} className="w-full m-auto">
                                    <Box className="flex flex-wrap md:flex-nowrap m-auto justify-center items-center gap-4 w-fit min-w-[240px]">
                                        <Button onClick={() => {
                                            if (window.history.length > 0) {
                                                navigate(-1)
                                            } else {
                                                navigate(routeName.e_library.books)
                                            }
                                        }} className='min-w-[120px] max-w-[120px]' sx={{ borderRadius: "8px" }} variant='outlined' fullWidth >ย้อนกลับ</Button>
                                        <Button
                                            disabled={checked_cart?.length === 0}
                                            onClick={async () => {
                                                const check_payment = await handleCheckLockItem(cart_data?.filter((x) => checked_cart.includes(x?.id_library_head)));
                                                if (check_payment) {
                                                    handlePayment();
                                                }
                                            }}
                                            className='min-w-[120px] max-w-[120px]'
                                            startIcon={<PriceCheckIcon />}
                                            color="success" variant='contained'
                                            fullWidth >
                                            ชำระเงิน
                                        </Button>
                                    </Box>
                                </Box>
                            )}
                        </React.Fragment>
                    )}


                </Box>
            }
        />
    )
}

export default ShoppingCartBooks